import { AuthServiceService } from 'src/app/services/auth-service.service';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { CognitoUserPool } from 'amazon-cognito-identity-js';

@Injectable({
    providedIn: 'root'
})
export class AuthGuardService implements CanActivate {

    private userPool = new CognitoUserPool(environment.userPool);

    constructor(public auth: AuthServiceService, public router: Router) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        if (this.isAuthenticated()) {
            return true;
        }

        // Only store the attempted URL if deep links are enabled for non-authenticated users
        if (environment.enableDeepLinksPreLogin) {
            // Store the attempted URL for redirecting after login
            const returnUrl = state.url;
            
            // Store the return URL in localStorage so it persists through the login process
            if (returnUrl && returnUrl !== '/' && returnUrl !== '/login') {
                localStorage.setItem('returnUrl', returnUrl);
            }
        }

        // Navigate to login
        this.router.navigate(['/login']);
        return false;
    }

    isAuthenticated(): boolean {
        const cognitoUser = this.userPool.getCurrentUser();

        if (cognitoUser == null) {
            return false;
        }

        return true;
    }
}
